import type { FC } from 'react'
import { twMerge } from 'tailwind-merge'

interface Props {
  text: string
  className?: string
}

export const Separator: FC<Props> = ({ text, className = '' }) => {
  return (
    <div className={twMerge('flex items-center select-none', className)}>
      <div className='border-t border-gray-300 w-full' />
      <div className='mx-4 text-gray-500 select-none'>{text}</div>
      <div className='border-t border-gray-300 w-full' />
    </div>
  )
}
